import { defineMessages } from 'react-intl';

export default defineMessages({
  retryButtonLabel: {
    id: 'frontbucket.jiraTab.errorWithRetry.retryButtonLabel',
    description:
      'Retry button label displayed when a request to fetch data failed and retrying that request might resolve the issue',
    defaultMessage: 'Try again',
  },
});
